import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
//import axios from "axios";
import axiosBaseURL from "../../../utilities/httpCommon";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";
import {
  Backdrop,
  CircularProgress,
  Card,
  CardHeader,
  Divider,
  Grid,
  List,
  ListItem,
  Typography,
  Chip,
  ListItemButton,
} from "@mui/material";

/* global console */

export interface CheckoutDialogProps {
  open: boolean;
  agreementId: any;
  agreementNumber: any;
  agreementVersion: any;
  onClose: (value?: any) => void;
}

export default function CheckoutDialog(props: CheckoutDialogProps) {
  const { onClose, agreementId, agreementNumber, agreementVersion, open, ...other } = props;
  const [isprogress, setprogress] = useState(false);
  const [autolist, setautolist] = useState([]);
  const [selectedIndex, setSelectedIndex] = React.useState(-1);
  const [errMsgd, seterrMsgd] = useState("");

  const handleCancel = () => {
    onClose();
  };

  const errorDismissed = () => {
    seterrMsgd("");
  };

  const handleOk = (selitem) => {
    onClose(selitem);
  };

  const QueryData = async (soqlquery: string, childrelation: boolean) => {
    try {
      setprogress(true);
      const res = await axiosBaseURL
        .get("/sfserver/query?q=" + soqlquery, {
          withCredentials: true,
        })
        .catch((error) => {
          setprogress(false);
          if (error.response) {
            seterrMsgd(error.response.data);
          } else if (error.request) {
            seterrMsgd(error.request);
          } else {
            seterrMsgd(error.message);
          }
        });
      setprogress(false);
      console.log("res.data");
      console.log(res.data);
      if (res.data != null) {
        if (!childrelation) return res.data.records;
        else if (childrelation) return res.data;
      } else return null;
    } catch (err) {
      setprogress(false);
    }
  };

  // function GetDateTextFormat(text: any) {
  //   let tmptext = text + "";
  //   if (tmptext != null && tmptext.indexOf("T") > 0) {
  //     tmptext = tmptext.split("T")[0];
  //   }
  //   return tmptext;
  // }

  const GetDoclistbyagreement = async (id: any) => {
    //Check for template version
    let templateIds = [];
    let lockIds = [];
    //let doclockid = await readLockVersionID();
    //let loginUsrid = localStorage.getItem("sfuserid");
    // if (doclockid != null && loginUsrid != null && loginUsrid != undefined) {
    //   var doclock = await QueryData(
    //     "SELECT Id, Locked_By__c,  Locked_By__r.Name, Type__c, Content_Version_Id__c, IsLocked__c FROM Document_Lock__c where Locked_By__c != '" +
    //       loginUsrid +
    //       "'",
    //     false
    //   );
    //   if (doclock != null) {
    //     doclock.map((item: any) => {
    //       lockIds.push({
    //         id: item.Id,
    //         name: item.Locked_By__r.Name,
    //         contentId: item.Content_Version_Id__c,
    //       });
    //     });
    //   }
    // }
    console.log("lockIds");
    console.log(lockIds);
    templateIds.push({
      id: id,
      name: agreementNumber,
      versionno: agreementVersion,
      type: "True",
      islocked: userExists(lockIds, id) ? true : false,
    });
    var versions = await QueryData(
      "SELECT Id, Name, Version_Number__c, LastModifiedDate, Comments__c FROM Template_Version__c where Template__c='" +
        id +
        "'",
      false
    );
    if (versions != null) {
      versions.map((item: any) => {
        templateIds.push({
          id: item.Id,
          name: item.Name,
          versionno: item.Version_Number__c,
          comments: item.Comments__c,
          type: "False",
          islocked: userExists(lockIds, item.Id) ? true : false,
        });
      });
    }
    console.log(templateIds);
    setautolist(templateIds);
    //Ends here
  };

  function userExists(arr, username) {
    if (arr.length === 0) {
      return false;
    }
    return arr.some(function (el) {
      return el.contentId === username;
    });
  }

  useEffect(() => {
    console.log("agreementId");
    if (agreementId != null && agreementId != "") {
      GetDoclistbyagreement(agreementId).then(() => {
        console.log("Done");
      });
    }
    console.log(agreementId);
  }, [props.agreementId]);

  return (
    <Dialog fullScreen sx={{ "& .MuiDialog-paper": { width: "100%" } }} maxWidth="xs" open={open} {...other}>
      <DialogContent sx={{ padding: 0 }}>
        <Card sx={{ padding: 0.5, margin: 1 }} elevation={0}>
          {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
          <CardHeader
            sx={{ margin: 0, padding: 0 }}
            subheaderTypographyProps={{ color: "#1C39BB", fontSize: 15 }}
            subheader="Select document"
          ></CardHeader>
          <Divider />
          <Grid container>
            <Grid item xs={6}>
              <Typography sx={{ fontSize: 14, marginTop: 2, fontWeight: "bold" }}>Template Name:</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ fontSize: 14, marginTop: 2, fontWeight: "bold" }}>{agreementNumber}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: 14, marginTop: 2, fontWeight: "bold" }}>Files:</Typography>
            </Grid>
            <Grid item xs={12}>
              <List
                dense
                sx={{
                  width: "100%",
                  position: "relative",
                  overflow: "auto",
                }}
              >
                {autolist.map((item, index) => (
                  <ListItem sx={{ margin: "0 px", padding: "0 px" }} divider disablePadding={true} key={index}>
                    <ListItemButton
                      key={index}
                      selected={selectedIndex === index}
                      onClick={() => {
                        setSelectedIndex(index);
                      }}
                      sx={{ padding: 0, pl: 2 }}
                    >
                      <Grid container>
                        <Grid item xs={12}>
                          Name: {item.name}
                        </Grid>
                        <Grid item xs={12}>
                          Is Active: {item.type}
                        </Grid>
                        <Grid item xs={12}>
                          Description: {item.comments}
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container>
                            <Grid item xs={8}>
                              Version: {item.versionno}
                            </Grid>
                            <Grid item xs={4}>
                              <Chip
                                onClick={() => handleOk(item)}
                                label="Open"
                                variant="filled"
                                sx={
                                  selectedIndex === index
                                    ? {
                                        height: "22px",
                                        display: "block",
                                        marginTop: 0,
                                        bgcolor: "#1C39BB",
                                        width: 56,
                                        alignContent: "flex-end",
                                        color: "white",
                                      }
                                    : { height: "22px", display: "none" }
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isprogress}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
